import HomeEndpoints from "../../lib/home/HomeEndpoints";

export const checkVersion = (shouldRedirectCallBack) => {
  const scriptsFound = [...document.getElementsByTagName("script")].filter((x) =>
    x.src.includes("main.")
  );

  const src = scriptsFound.map((x) => x.src)[0];

  if (src) {
    const splitBySlash = src.split("/");

    const lastPart = splitBySlash[splitBySlash.length - 1];

    if (lastPart) {
      const isBeta = document.location.href.includes("preprod");

      const currentVersion = lastPart.split(".")[1];

      const urlParams = new URLSearchParams(window.location.search);
      const workstationID = urlParams.get("ws");

      HomeEndpoints.getVersion(workstationID, isBeta).then((result) => {
        if (currentVersion && currentVersion !== result.version && currentVersion !== "chunk") {
          fetch(src.replace(lastPart, "main." + result.version + ".chunk.js"))
            .then((x) => {
              if (x.status === 200) {
                window.location.reload();
              } else if (x.status === 404 && !currentVersion.includes("chunk")) {
                console.log(`unable to fetch file, going to fallback, current version: ${currentVersion}, target vesrion: ${result.version}`);
                _srcChangeFallback(src, lastPart, result);
              }
            })
            .catch();
        } else if (result.shouldRedirect) {
          console.log("shouldRedirect");
          if (shouldRedirectCallBack) shouldRedirectCallBack(true);
        }
      });
    }
  }
};

function _srcChangeFallback(src, lastPart, result) {
  fetch(src.replace(lastPart, "main." + result.version + ".js"))
    .then((x) => {
      if (x.status === 200) {
        window.location.reload();
      }
    });
}

